package com.catbit.opinionpoll.inputs.inputs

//TODO Alterar actualIdentifier x identifier
data class QuestionInput(
    val actualIdentifier: String,
    val identifier: String,
    val title: String
)